<section class="container">
    <ng-content select="[sopTitle]"></ng-content>
  <div class="container__chip">
    <ng-content select="[sopChip]"></ng-content>
  </div>
</section>
